import React from 'react';
import {
  EVBox,
  EVDialog,
  EVTypography,
  EVButton,
  EVIconButton,
  EVClear,
  EVDivider,
  EVDialogActions,
} from '@eagleview/ev-comp-library';
import { bool, func, number } from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { resetOrderToReadyForReviewAction } from 'layout/adjuster/Adjuster.actions';
import useStyles from './ResetDecisions.styles';

const resetDecisions = ({ open, handleClose, orderId }) => {
  // hooks
  const styles = useStyles();
  // actions
  const dispatch = useDispatch();
  const resetOrderToReadyForReview = (payload) => dispatch(resetOrderToReadyForReviewAction(payload));

  const handleResetDecision = () => {
    resetOrderToReadyForReview({ orderId, retainData: false, resetDecisions: true });
    handleClose();
  };

  const { t } = useTranslation();
  return (
    <EVDialog data-testid="reset-decision-dialog" open={open} onClose={handleClose}>
      <EVBox
        display="flex"
        flexDirection="column"
        justifyContent="space-between"
        width="470px"
        height="200px"
      >
        <EVBox className={styles.alignContent} pt={1}>
          <EVBox className={styles.title} display="flex" justifyContent="space-between" alignItems="center">
            <EVTypography className={styles.titleText}>{t('adjusterMenu.resetDecisions')}</EVTypography>
            <EVIconButton
              onClick={handleClose}
              data-testid="close-button"
              size="small"
            >
              <EVClear />
            </EVIconButton>
          </EVBox>
        </EVBox>
        <EVDivider />
        <EVBox className={styles.alignContent} pt={2}>
          <EVTypography className={styles.ConfirmationText}>{t('adjusterMenu.resetDecisionsConfirmation')}</EVTypography>
        </EVBox>

        <EVDialogActions className={styles.actionButtons}>
          <EVButton
            className={styles.button}
            data-testid="cancelBtn"
            onClick={() => {
              handleClose();
            }}
            color="primary"
          >
            {t('cancel')}
          </EVButton>
          <EVButton
            className={styles.button}
            onClick={handleResetDecision}
            data-testid="submit-button"
            variant="contained"
            color="primary"
          >
            {t('adjusterMenu.resetButton')}
          </EVButton>
        </EVDialogActions>
      </EVBox>
    </EVDialog>
  );
};

resetDecisions.propTypes = {
  open: bool.isRequired,
  handleClose: func.isRequired,
  orderId: number.isRequired,
};

export default resetDecisions;
